import {ExclamationCircleIcon, ReportsIcon} from '@rocket-ui/icons';
import cn from 'classnames';
import React, {FC, ReactElement, SVGAttributes, SVGProps} from 'react';

import styles from './icons.module.css';

function createIcon(svg: ReactElement<SVGProps<SVGSVGElement>>): FC<SVGProps<SVGSVGElement>> {
	return (props) => React.cloneElement(svg, props);
}

const ArchiveIcon = createIcon(
	<svg viewBox="0 0 24 24">
		<path
			d="M3.5 4C3.22386 4 3 4.22386 3 4.5V6.5C3 6.77614 3.22386 7 3.5 7H20.5C20.7761 7 21 6.77614 21 6.5V4.5C21 4.22386 20.7761 4 20.5 4H3.5Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4 9.5C4 9.22386 4.22386 9 4.5 9H19.5C19.7761 9 20 9.22386 20 9.5V19.5C20 19.7761 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7761 4 19.5V9.5ZM9 13C9 12.4477 9.44772 12 10 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H10C9.44772 14 9 13.5523 9 13Z"
			fill="currentColor"
		/>
	</svg>,
);

const ActiveTasksIcon = createIcon(
	<svg viewBox="0 0 24 24">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.79995 7.2C1.46858 7.2 1.19995 7.46863 1.19995 7.8V22.2C1.19995 22.5314 1.46858 22.8 1.79995 22.8H22.1999C22.5313 22.8 22.7999 22.5314 22.7999 22.2V7.8C22.7999 7.46863 22.5313 7.2 22.1999 7.2H1.79995ZM12.3761 18.9364C12.6208 18.9364 12.7935 18.7554 12.8367 18.5187C13.2686 15.7762 13.3262 15.6509 16.2915 15.1637C16.565 15.1219 16.7378 14.9688 16.7378 14.7182C16.7378 14.4676 16.565 14.3145 16.3203 14.2727C13.3164 13.7445 13.2974 13.6327 12.8388 10.9302L12.8367 10.9176C12.7935 10.6671 12.6208 10.5 12.3761 10.5C12.117 10.5 11.9442 10.6671 11.9154 10.9037C11.4692 13.688 11.426 13.7994 8.43183 14.2727C8.17272 14.3145 7.99998 14.4676 7.99998 14.7182C7.99998 14.9688 8.17272 15.1219 8.41743 15.1637C11.3876 15.6859 11.4115 15.8147 11.8964 18.43C11.9027 18.4638 11.909 18.498 11.9154 18.5327C11.9442 18.7554 12.117 18.9364 12.3761 18.9364Z"
			fill="currentColor"
		/>
		<path
			d="M19.4 3H4.59998C4.2686 3 3.99998 3.26863 3.99998 3.6V5.5H20V3.6C20 3.26863 19.7313 3 19.4 3Z"
			fill="currentColor"
		/>
	</svg>,
);

const InboxIcon = createIcon(
	<svg viewBox="0 0 24 24">
		<path
			d="M4.49983 9.63155L5.76296 5H18.2356L19.4987 9.63155C19.5276 9.73737 19.5904 9.83077 19.6776 9.89735C19.7648 9.96393 19.8714 10 19.9811 10H21.1484C21.2099 10 21.2705 9.98582 21.3257 9.95855C21.3808 9.93128 21.4289 9.89167 21.4662 9.84279C21.5036 9.79392 21.5291 9.73709 21.5409 9.67672C21.5527 9.61636 21.5504 9.55409 21.5343 9.49475L19.8634 3.36844C19.8346 3.26262 19.7717 3.16922 19.6845 3.10264C19.5974 3.03607 19.4907 3 19.381 3H4.61748C4.5078 3 4.40116 3.03607 4.31399 3.10265C4.22682 3.16923 4.16397 3.26262 4.1351 3.36844L2.46427 9.49475C2.44809 9.55409 2.44581 9.61636 2.45761 9.67672C2.4694 9.73709 2.49496 9.79392 2.53229 9.84279C2.56963 9.89167 2.61773 9.93128 2.67286 9.95855C2.72799 9.98582 2.78867 10 2.85017 10H4.01744C4.12713 10 4.23378 9.96393 4.32095 9.89735C4.40812 9.83077 4.47098 9.73737 4.49983 9.63155Z"
			fill="currentColor"
		/>
		<path
			d="M16.8508 12.2226L15.1477 14.7774C15.102 14.8458 15.0402 14.902 14.9676 14.9408C14.895 14.9797 14.814 15 14.7317 15H9.26686C9.18455 15 9.10351 14.9797 9.03094 14.9408C8.95837 14.902 8.89651 14.8458 8.85086 14.7774L7.14772 12.2226C7.10206 12.1542 7.04019 12.098 6.96761 12.0592C6.89504 12.0203 6.81399 12 6.73168 12H1.49927C1.36666 12 1.23948 12.0527 1.14571 12.1464C1.05195 12.2402 0.999268 12.3674 0.999268 12.5V21.5C0.999268 21.6326 1.05195 21.7598 1.14571 21.8536C1.23948 21.9473 1.36666 22 1.49927 22H22.4993C22.6319 22 22.7591 21.9473 22.8528 21.8536C22.9466 21.7598 22.9993 21.6326 22.9993 21.5V12.5C22.9993 12.3674 22.9466 12.2402 22.8528 12.1464C22.7591 12.0527 22.6319 12 22.4993 12H17.2669C17.1845 12 17.1035 12.0203 17.0309 12.0592C16.9584 12.098 16.8965 12.1542 16.8508 12.2226Z"
			fill="currentColor"
		/>
		<path
			d="M7.51163 10H16.3589C16.4349 10 16.5099 9.98268 16.5782 9.94936C16.6465 9.91604 16.7063 9.86759 16.753 9.8077C16.7998 9.74781 16.8323 9.67805 16.8481 9.60372C16.8638 9.52939 16.8624 9.45244 16.844 9.37873L16.594 8.37873C16.567 8.27055 16.5045 8.17452 16.4166 8.1059C16.3287 8.03727 16.2204 8 16.1089 8H7.88971C7.7782 8 7.6699 8.03728 7.58201 8.1059C7.49411 8.17453 7.43169 8.27056 7.40464 8.37874L7.12357 9.503C7.10883 9.56197 7.10773 9.62353 7.12034 9.68299C7.13295 9.74245 7.15895 9.79826 7.19636 9.84617C7.23376 9.89408 7.2816 9.93284 7.33623 9.95949C7.39086 9.98615 7.45085 10 7.51163 10Z"
			fill="currentColor"
		/>
	</svg>,
);

const LockIcon = createIcon(
	<svg viewBox="0 0 24 24" fill="currentColor">
		<path d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10H19.5C19.7761 10 20 10.2239 20 10.5V19.5C20 19.7762 19.7761 20 19.5 20H4.5C4.22386 20 4 19.7762 4 19.5V10.5C4 10.2239 4.22386 10 4.5 10H7V8ZM12 4.99994C10.3431 4.99994 9 6.34309 9 7.99994V9.99994H15V7.99994C15 6.34309 13.6569 4.99994 12 4.99994Z" />
	</svg>,
);

const ShieldIcon = createIcon(
	<svg viewBox="0 0 24 24" fill="currentColor">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.4647 2.64851L3 4.99982V11.5274C3 15.5222 5.16581 19.203 8.65793 21.1431L11.7572 22.8649C11.9082 22.9488 12.0918 22.9488 12.2428 22.8649L15.3421 21.1431C18.8342 19.203 21 15.5222 21 11.5274V4.99982L12.5353 2.64851C12.1851 2.55122 11.8149 2.55122 11.4647 2.64851ZM16.1589 10.0406C16.3436 9.83536 16.3269 9.51922 16.1217 9.33449L15.3784 8.66552C15.1731 8.48079 14.857 8.49743 14.6723 8.70269L11.1507 12.6155L9.27434 11.0519C9.0622 10.8751 8.74692 10.9038 8.57014 11.1159L7.92996 11.8841C7.75317 12.0963 7.78184 12.4115 7.99397 12.5883L10.9796 15.0764C11.1861 15.2484 11.4916 15.2265 11.6714 15.0267L16.1589 10.0406Z"
		/>
	</svg>,
);

export default {
	acts: ActsIcon,
	attach: AttachIcon,
	archive: ArchiveIcon,
	'active-tasks': ActiveTasksIcon,
	'arrow-up': ArrowUpIcon,
	'arrow-down': ArrowDownIcon,
	'arrow-left': ArrowLeftIcon,
	'arrow-right': ArrowRightIcon,
	'arrow-up-left': ArrowUpLeftIcon,
	'additional-info': AdditionalInfo,
	'back-big': BackBigIcon,
	bag: BagIcon,
	check: CheckIcon,
	'check-big': CheckBigIcon,
	'chevron-down': ChevronDownIcon,
	'chevron-up': ChevronUpIcon,
	'chevron-left': ChevronLeftIcon,
	'chevron-right': ChevronRightIcon,
	complete: CompleteIcon,
	cross: CrossIcon,
	'cross-mini': CrossMiniIcon,
	copy: CopyIcon,
	'copy-mini': CopyMiniIcon,
	document: DocumentIcon,
	dots: DotsIcon,
	download: DownloadIcon,
	'edit-big': EditBigIcon,
	eye: EyeIcon,
	'eye-off': EyeOffIcon,
	exclamation: ExclamationCircleIcon,
	exit: ExitIcon,
	findWorkers: FindWorkersIcon,
	folder: FolderIcon,
	history: HistoryIcon,
	inbox: InboxIcon,
	information: InformationIcon,
	link: LinkIcon,
	loading: LoadingIcon,
	lock: LockIcon,
	'minus-mini': MinusMiniIcon,
	pay: PayIcon,
	phone: PhoneIcon,
	plus: PlusIcon,
	'plus-mini': PlusMiniIcon,
	profile: ProfileIcon,
	receipt: ReceiptIcon,
	recover: RecoverIcon,
	remove: RemoveIcon,
	'remove-mini': RemoveMiniIcon,
	trash: TrashIcon,
	repeat: RepeatIcon,
	shield: ShieldIcon,
	signature: SignatureIcon,
	'signature-mini': SignatureMiniIcon,
	warning: WarningIcon,
	wallet: WalletIcon,
	registry: RegistryIcon,
	error: ErrorIcon,
	'error-circle': ErrorCircleIcon,
	safe: SafeIcon,
	search: SearchIcon,
	personalInfo: PersonalInfo,
	stats: Stats,
	edit: Edit,
	worker: Worker,
	copy2: Copy2,
	threeDots: ThreeDots,
	externalLink: ExternalLink,
	union: UnionIcon,
	key: KeyIcon,
	language: LanguageIcon,
	hamburger: HamburgerIcon,
	reports: ReportsIcon,
	question: QuestionIcon,
};

function ActsIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M9.5 0.50001C9.22386 0.50001 9 0.723868 9 1.00001V3.00001C9 3.27615 9.22386 3.50001 9.5 3.50001H14.5C14.7761 3.50001 15 3.27615 15 3.00001V1.00001C15 0.723868 14.7761 0.50001 14.5 0.50001H9.5Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.50002 1.99961C3.22387 1.9996 3 2.22346 3 2.49961V22.5C3 22.7761 3.22386 23 3.5 23H20.5C20.7761 23 21 22.7761 21 22.5V2.49977C21 2.22363 20.7761 1.99977 20.5 1.99977H17.5C17.2239 1.99977 17 2.22363 17 2.49977V5C17 5.27614 16.7761 5.5 16.5 5.5H7.5C7.22386 5.5 7 5.27614 7 5V2.49975C7 2.22361 6.77616 1.99976 6.50002 1.99975L3.50002 1.99961ZM15.5 10.0001C15.2239 10.0001 15 10.224 15 10.5001V11.5001C15 11.7762 15.2239 12.0001 15.5 12.0001H16.5C16.7761 12.0001 17 11.7762 17 11.5001V10.5001C17 10.224 16.7761 10.0001 16.5 10.0001H15.5ZM15 15.5001C15 15.224 15.2239 15.0001 15.5 15.0001H16.5C16.7761 15.0001 17 15.224 17 15.5001V16.5001C17 16.7762 16.7761 17.0001 16.5 17.0001H15.5C15.2239 17.0001 15 16.7762 15 16.5001V15.5001ZM7.5 10.0001C7.22386 10.0001 7 10.224 7 10.5001V11.5001C7 11.7762 7.22386 12.0001 7.5 12.0001H12.5C12.7761 12.0001 13 11.7762 13 11.5001V10.5001C13 10.224 12.7761 10.0001 12.5 10.0001H7.5ZM7 15.5001C7 15.224 7.22386 15.0001 7.5 15.0001H12.5C12.7761 15.0001 13 15.224 13 15.5001V16.5001C13 16.7762 12.7761 17.0001 12.5 17.0001H7.5C7.22386 17.0001 7 16.7762 7 16.5001V15.5001Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function AttachIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="14" height="16" viewBox="0 0 14 16" fill="none" {...props}>
			<path
				d="M9.24277 4.44938L9.55035 4.75666C9.74578 4.95189 9.74585 5.26861 9.55052 5.46394L4.83025 10.1842C4.70502 10.3206 4.63734 10.5001 4.64134 10.6853C4.64534 10.8704 4.72072 11.0468 4.85172 11.1777C4.98273 11.3086 5.15923 11.3838 5.34437 11.3876C5.52951 11.3914 5.70896 11.3236 5.84525 11.1982L11.9353 5.10921C12.7743 4.27021 12.7753 2.90521 11.9353 2.06521C11.0953 1.22521 9.72925 1.22521 8.89025 2.06521L2.49525 8.45821L2.49625 8.45921C2.16238 8.79014 1.8971 9.18371 1.71564 9.61736C1.53419 10.051 1.44011 10.5162 1.43881 10.9863C1.43751 11.4564 1.52901 11.9221 1.70807 12.3568C1.88712 12.7914 2.15021 13.1864 2.48225 13.5192C3.87425 14.9112 6.13825 14.9112 7.53025 13.5192L7.54325 13.5062L11.5549 9.49643C11.7501 9.30131 12.0665 9.30127 12.2617 9.49634L12.5693 9.80362C12.7648 9.99887 12.7648 10.3156 12.5694 10.5109L8.55825 14.5212L8.55725 14.5202L8.54425 14.5342C6.58925 16.4882 3.42125 16.4882 1.46625 14.5342C-0.48875 12.5802 -0.48875 9.41221 1.46625 7.45721L1.48025 7.44421L7.87425 1.05121C8.5471 0.378227 9.45974 9.37856e-05 10.4114 0C11.3631 -9.37507e-05 12.2758 0.377859 12.9488 1.05071C13.6217 1.72357 13.9999 2.63621 14 3.58786C14.0001 4.53951 13.6221 5.45223 12.9493 6.12521L6.85925 12.2142C6.65938 12.4142 6.42208 12.5728 6.16091 12.681C5.89974 12.7892 5.61981 12.845 5.3371 12.845C5.0544 12.845 4.77445 12.7894 4.51324 12.6813C4.25204 12.5731 4.01469 12.4146 3.81475 12.2147C3.61481 12.0148 3.4562 11.7775 3.34797 11.5164C3.23974 11.2552 3.18401 10.9753 3.18396 10.6926C3.18392 10.4099 3.23955 10.1299 3.3477 9.8687C3.45584 9.6075 3.61438 9.37015 3.81425 9.17021L8.53587 4.44952C8.73107 4.25436 9.04749 4.2543 9.24277 4.44938Z"
				fill="black"
			/>
		</svg>
	);
}

function ArrowUpIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4999 19C11.2238 19 10.9999 18.7761 10.9999 18.5V8.82843L8.06059 11.7678C7.86532 11.963 7.54874 11.963 7.35348 11.7678L6.64637 11.0607C6.45111 10.8654 6.45111 10.5488 6.64637 10.3536L11.7171 5.28284C11.8733 5.12663 12.1266 5.12663 12.2828 5.28284L17.3535 10.3536C17.5487 10.5488 17.5487 10.8654 17.3535 11.0607L16.6464 11.7678C16.4511 11.963 16.1345 11.963 15.9393 11.7678L12.9999 8.82843V18.5C12.9999 18.7761 12.7761 19 12.4999 19H11.4999Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ArrowDownIcon({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return <ArrowUpIcon className={cn(className, styles.rotate180)} {...restProps} />;
}

function ArrowLeftIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.9998 12.5C18.9998 12.7761 18.776 13 18.4998 13H8.82827L11.7676 15.9393C11.9629 16.1346 11.9629 16.4512 11.7676 16.6464L11.0605 17.3536C10.8652 17.5488 10.5487 17.5488 10.3534 17.3536L5.28268 12.2828C5.12647 12.1266 5.12648 11.8734 5.28268 11.7172L10.3534 6.64645C10.5487 6.45118 10.8652 6.45118 11.0605 6.64645L11.7676 7.35355C11.9629 7.54882 11.9629 7.8654 11.7676 8.06066L8.82827 11H18.4998C18.776 11 18.9998 11.2239 18.9998 11.5V12.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ArrowRightIcon({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return <ArrowLeftIcon className={cn(className, styles.rotate180)} {...restProps} />;
}

function ArrowUpLeftIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" {...props}>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.75 11.54V.741a.492.492 0 0 0-.492-.491H4.46a.677.677 0 0 0-.677.677v1.235c0 .374.303.677.677.677h6.87L.448 13.721a.677.677 0 0 0 0 .957l.874.873a.677.677 0 0 0 .957 0L13.16 4.671v6.87c0 .373.303.676.677.676h1.236a.677.677 0 0 0 .677-.677Z"
			/>
		</svg>
	);
}

function AdditionalInfo({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg viewBox="0 0 10 10" fill="none" {...restProps}>
			<path
				d="M8.701 8.35631L9.79995 6.46839L6.43995 5.01235L9.79995 3.55631L8.701 1.65605L5.70732 3.82778L6.11153 0.200012H3.88837L4.29258 3.82778L1.28627 1.65605L0.199951 3.55631L3.55995 5.01235L0.199951 6.46839L1.28627 8.35631L4.27995 6.22161L3.88837 9.80001H6.11153L5.71995 6.23394L8.701 8.35631Z"
				fill="black"
			/>
		</svg>
	);
}

function BackBigIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.70711 12L15.6464 5.06067C15.8417 4.86541 15.8417 4.54883 15.6464 4.35357L14.9393 3.64646C14.7441 3.4512 14.4275 3.4512 14.2322 3.64646L6.23223 11.6465C6.03697 11.8417 6.03697 12.1583 6.23223 12.3536L14.2322 20.3536C14.4275 20.5488 14.7441 20.5488 14.9393 20.3536L15.6464 19.6465C15.8417 19.4512 15.8417 19.1346 15.6464 18.9394L8.70711 12Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function BagIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18 1.5V6H22.5C22.6326 6 22.7598 6.05268 22.8536 6.14645C22.9473 6.24021 23 6.36739 23 6.5V11H1V6.5C1 6.36739 1.05268 6.24021 1.14645 6.14645C1.24021 6.05268 1.36739 6 1.5 6H6V1.5C6 1.36739 6.05268 1.24021 6.14645 1.14645C6.24021 1.05268 6.36739 1 6.5 1H17.5C17.6326 1 17.7598 1.05268 17.8536 1.14645C17.9473 1.24021 18 1.36739 18 1.5ZM8 3V6H16V3H8Z"
				fill="currentColor"
			/>
			<path
				d="M10.5 15H13.5C13.6326 15 13.7598 14.9473 13.8536 14.8536C13.9473 14.7598 14 14.6326 14 14.5V13H23V21.5C23 21.6326 22.9473 21.7598 22.8536 21.8536C22.7598 21.9473 22.6326 22 22.5 22H1.5C1.36739 22 1.24021 21.9473 1.14645 21.8536C1.05268 21.7598 1 21.6326 1 21.5V13H10V14.5C10 14.6326 10.0527 14.7598 10.1464 14.8536C10.2402 14.9473 10.3674 15 10.5 15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CheckIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				d="M8.5709 14.1887L4.72919 10.9045C4.68759 10.8689 4.65341 10.8255 4.62858 10.7768C4.60376 10.728 4.58879 10.6748 4.58452 10.6203C4.58025 10.5657 4.58677 10.5108 4.60371 10.4588C4.62065 10.4068 4.64767 10.3586 4.68323 10.317L5.2249 9.68338C5.26045 9.64178 5.30386 9.6076 5.35263 9.58278C5.4014 9.55796 5.45458 9.54299 5.50913 9.53873C5.56369 9.53446 5.61855 9.54099 5.67058 9.55793C5.72262 9.57487 5.77081 9.60189 5.8124 9.63745L8.70368 12.11L14.0498 5.8572C14.1216 5.77321 14.2238 5.72119 14.334 5.71257C14.4442 5.70396 14.5532 5.73945 14.6372 5.81125L15.2709 6.35292C15.3125 6.38848 15.3467 6.43188 15.3715 6.48065C15.3963 6.52942 15.4113 6.5826 15.4155 6.63715C15.4198 6.69171 15.4133 6.74657 15.3963 6.79861C15.3794 6.85064 15.3524 6.89883 15.3168 6.94042L9.15835 14.1428C9.08654 14.2268 8.98431 14.2788 8.87414 14.2874C8.76397 14.296 8.65489 14.2605 8.5709 14.1887Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CheckBigIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.8299 5.77483C21.0398 5.9543 21.0645 6.26992 20.885 6.4798L10.4149 18.724C10.2355 18.9339 9.91987 18.9585 9.70999 18.779L3.18006 13.1954C2.97019 13.016 2.94553 12.7003 3.12499 12.4905L3.77488 11.7304C3.95434 11.5206 4.26996 11.4959 4.47984 11.6754L9.86974 16.2842L19.365 5.18C19.5444 4.97012 19.8601 4.94547 20.0699 5.12494L20.8299 5.77483Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ChevronDownIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M11.6464 15.207L6.64645 10.2071C6.60002 10.1606 6.56319 10.1055 6.53806 10.0448C6.51293 9.98418 6.5 9.91916 6.5 9.8535C6.5 9.78784 6.51293 9.72282 6.53806 9.66216C6.56319 9.6015 6.60002 9.54638 6.64645 9.49995L7.35345 8.793C7.44722 8.69923 7.57439 8.64655 7.707 8.64655C7.8396 8.64655 7.96678 8.69923 8.06055 8.793L11.9999 12.7324L15.9393 8.79299C16.0331 8.69922 16.1603 8.64655 16.2929 8.64655C16.4255 8.64655 16.5527 8.69922 16.6464 8.79299L17.3534 9.49994C17.3999 9.54637 17.4367 9.60149 17.4618 9.66215C17.487 9.72281 17.4999 9.78783 17.4999 9.85349C17.4999 9.91916 17.487 9.98417 17.4618 10.0448C17.4367 10.1055 17.3999 10.1606 17.3534 10.207L12.3535 15.207C12.2597 15.3008 12.1325 15.3534 11.9999 15.3534C11.8673 15.3534 11.7401 15.3008 11.6464 15.207Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ChevronUpIcon({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return <ChevronDownIcon className={cn(className, styles.rotate180)} {...restProps} />;
}

function ChevronLeftIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M12.7929 17.3535L7.79293 12.3535C7.69916 12.2598 7.64648 12.1326 7.64648 12C7.64648 11.8674 7.69916 11.7402 7.79293 11.6464L12.7928 6.64651C12.8393 6.60008 12.8944 6.56325 12.9551 6.53812C13.0157 6.51299 13.0807 6.50006 13.1464 6.50006C13.2121 6.50006 13.2771 6.51299 13.3377 6.53812C13.3984 6.56325 13.4535 6.60008 13.5 6.64651L14.2069 7.35351C14.3007 7.44728 14.3534 7.57445 14.3534 7.70706C14.3534 7.83967 14.3007 7.96684 14.2069 8.06061L10.2675 12L14.2069 15.9394C14.3007 16.0332 14.3534 16.1604 14.3534 16.293C14.3534 16.4256 14.3007 16.5527 14.2069 16.6465L13.5 17.3535C13.4535 17.3999 13.3984 17.4368 13.3378 17.4619C13.2771 17.487 13.2121 17.4999 13.1464 17.4999C13.0807 17.4999 13.0157 17.487 12.9551 17.4619C12.8944 17.4367 12.8393 17.3999 12.7929 17.3535Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ChevronRightIcon({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return <ChevronLeftIcon className={cn(className, styles.rotate180)} {...restProps} />;
}

function CompleteIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M11.9998 1C9.82417 1 7.69743 1.64514 5.88849 2.85383C4.07955 4.06253 2.66965 5.78049 1.83709 7.79048C1.00452 9.80047 0.786685 12.0122 1.21112 14.146C1.63556 16.2798 2.68321 18.2398 4.22159 19.7782C5.75996 21.3166 7.71998 22.3642 9.85377 22.7886C11.9876 23.2131 14.1993 22.9952 16.2093 22.1627C18.2193 21.3301 19.9372 19.9202 21.1459 18.1113C22.3546 16.3023 22.9998 14.1756 22.9998 12C22.9998 9.08262 21.8408 6.28473 19.7779 4.22183C17.715 2.15893 14.9171 1 11.9998 1ZM18.2978 8.9964L11.4048 17.0584C11.3622 17.1083 11.3101 17.1493 11.2515 17.1791C11.193 17.2089 11.1292 17.2269 11.0637 17.232C10.9983 17.2371 10.9324 17.2293 10.87 17.2089C10.8076 17.1886 10.7497 17.1562 10.6998 17.1135L6.40039 13.4373C6.35047 13.3946 6.30945 13.3426 6.27966 13.284C6.24988 13.2255 6.23192 13.1617 6.2268 13.0962C6.22169 13.0307 6.22953 12.9649 6.24987 12.9024C6.27021 12.84 6.30265 12.7821 6.34534 12.7322L6.99518 11.9726C7.08136 11.8719 7.20402 11.8095 7.3362 11.7991C7.46838 11.7888 7.59924 11.8314 7.70002 11.9175L10.8591 14.6182L16.7775 7.69716C16.8637 7.59642 16.9863 7.53401 17.1185 7.52366C17.2507 7.51332 17.3815 7.55588 17.4823 7.64199L18.2424 8.29134C18.2924 8.33399 18.3334 8.38607 18.3632 8.44459C18.3931 8.50311 18.411 8.56694 18.4162 8.63241C18.4213 8.69789 18.4135 8.76374 18.3932 8.82619C18.3728 8.88865 18.3404 8.94648 18.2978 8.9964Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CrossIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M17.8535 6.8534L17.1466 6.14645C17.1002 6.10002 17.045 6.06319 16.9844 6.03806C16.9237 6.01293 16.8587 6 16.793 6C16.7274 6 16.6624 6.01293 16.6017 6.03806C16.541 6.06319 16.4859 6.10002 16.4395 6.14645L12 10.5859L7.56051 6.14645C7.51408 6.10002 7.45896 6.06319 7.3983 6.03806C7.33763 6.01293 7.27261 6 7.20695 6C7.14129 6 7.07627 6.01293 7.01561 6.03806C6.95495 6.06319 6.89983 6.10002 6.8534 6.14645L6.14645 6.85345C6.10002 6.89988 6.06319 6.955 6.03806 7.01566C6.01293 7.07632 6 7.14134 6 7.207C6 7.27266 6.01293 7.33768 6.03806 7.39835C6.06319 7.45901 6.10002 7.51413 6.14645 7.56056L10.5859 12L6.14645 16.4395C6.10002 16.4859 6.06319 16.541 6.03806 16.6017C6.01293 16.6624 6 16.7274 6 16.793C6 16.8587 6.01293 16.9237 6.03806 16.9844C6.06319 17.045 6.10002 17.1002 6.14645 17.1466L6.85345 17.8535C6.89988 17.9 6.955 17.9368 7.01566 17.9619C7.07632 17.9871 7.14134 18 7.207 18C7.27266 18 7.33768 17.9871 7.39835 17.9619C7.45901 17.9368 7.51413 17.9 7.56056 17.8535L12 13.4141L16.4395 17.8535C16.4859 17.9 16.541 17.9368 16.6017 17.9619C16.6624 17.9871 16.7274 18 16.793 18C16.8587 18 16.9237 17.9871 16.9844 17.9619C17.045 17.9368 17.1002 17.9 17.1466 17.8535L17.8535 17.1466C17.9 17.1002 17.9368 17.045 17.9619 16.9844C17.9871 16.9237 18 16.8587 18 16.793C18 16.7274 17.9871 16.6624 17.9619 16.6017C17.9368 16.541 17.9 16.4859 17.8535 16.4395L13.4141 12L17.8535 7.56051C17.9 7.51408 17.9368 7.45896 17.9619 7.3983C17.9871 7.33763 18 7.27261 18 7.20695C18 7.14129 17.9871 7.07627 17.9619 7.01561C17.9368 6.95495 17.9 6.89983 17.8535 6.8534Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CrossMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M16.8534 7.8535L16.1464 7.1465C16.0527 7.05274 15.9255 7.00006 15.7929 7.00006C15.6603 7.00006 15.5331 7.05274 15.4393 7.1465L12 10.586L8.56054 7.14654C8.46678 7.05278 8.3396 7.0001 8.20699 7.0001C8.07439 7.0001 7.94721 7.05278 7.85344 7.14654L7.14644 7.85354C7.05268 7.94731 7 8.07449 7 8.20709C7 8.3397 7.05268 8.46688 7.14644 8.56064L10.5859 12L7.14648 15.4394C7.05272 15.5332 7.00004 15.6604 7.00004 15.793C7.00004 15.9256 7.05272 16.0528 7.14648 16.1465L7.85348 16.8535C7.94725 16.9473 8.07443 17 8.20703 17C8.33964 17 8.46682 16.9473 8.56058 16.8535L12 13.4141L15.4394 16.8535C15.5332 16.9473 15.6603 16.9999 15.7929 16.9999C15.9255 16.9999 16.0527 16.9473 16.1465 16.8535L16.8535 16.1465C16.9472 16.0527 16.9999 15.9256 16.9999 15.793C16.9999 15.6603 16.9472 15.5332 16.8535 15.4394L13.414 12L16.8534 8.5606C16.9472 8.46684 16.9999 8.33966 16.9999 8.20705C16.9999 8.07445 16.9472 7.94727 16.8534 7.8535Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CopyIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17 1.5V4.5C17 4.63261 16.9473 4.75979 16.8536 4.85355C16.7598 4.94732 16.6326 5 16.5 5H5V16.5C5 16.6326 4.94732 16.7598 4.85355 16.8536C4.75979 16.9473 4.63261 17 4.5 17H1.5C1.36739 17 1.24021 16.9473 1.14645 16.8536C1.05268 16.7598 1 16.6326 1 16.5V1.5C1 1.36739 1.05268 1.24021 1.14645 1.14645C1.24021 1.05268 1.36739 1 1.5 1H16.5C16.6326 1 16.7598 1.05268 16.8536 1.14645C16.9473 1.24021 17 1.36739 17 1.5ZM7.61538 7H22.3846C22.7245 7 23 7.27552 23 7.61538V22.3846C23 22.7245 22.7245 23 22.3846 23H7.61538C7.27552 23 7 22.7245 7 22.3846V7.61538C7 7.27552 7.27552 7 7.61538 7ZM14.5 10C14.2239 10 14 10.2239 14 10.5V14H10.5C10.2239 14 10 14.2239 10 14.5V15.5C10 15.7761 10.2239 16 10.5 16H14V19.5C14 19.7761 14.2239 20 14.5 20H15.5C15.7761 20 16 19.7761 16 19.5V16H19.5C19.7761 16 20 15.7761 20 15.5V14.5C20 14.2239 19.7761 14 19.5 14H16V10.5C16 10.2239 15.7761 10 15.5 10H14.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function CopyMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M12.7273 4.27273V5.90909C12.7273 5.98142 12.6985 6.05079 12.6474 6.10194C12.5962 6.15308 12.5269 6.18182 12.4545 6.18182H6.18182V12.4545C6.18182 12.5269 6.15308 12.5962 6.10194 12.6474C6.05079 12.6985 5.98142 12.7273 5.90909 12.7273H4.27273C4.2004 12.7273 4.13103 12.6985 4.07988 12.6474C4.02873 12.5962 4 12.5269 4 12.4545V4.27273C4 4.2004 4.02873 4.13103 4.07988 4.07988C4.13103 4.02873 4.2004 4 4.27273 4H12.4545C12.5269 4 12.5962 4.02873 12.6474 4.07988C12.6985 4.13103 12.7273 4.2004 12.7273 4.27273Z"
				fill="currentColor"
			/>
			<path
				d="M7.60839 7.27273H15.6643C15.8497 7.27273 16 7.42301 16 7.60839V15.6643C16 15.8497 15.8497 16 15.6643 16H7.60839C7.42301 16 7.27273 15.8497 7.27273 15.6643V7.60839C7.27273 7.42301 7.42301 7.27273 7.60839 7.27273ZM11.3636 8.90909C11.213 8.90909 11.0909 9.0312 11.0909 9.18182V11.0909H9.18182C9.0312 11.0909 8.90909 11.213 8.90909 11.3636V11.9091C8.90909 12.0597 9.0312 12.1818 9.18182 12.1818H11.0909V14.0909C11.0909 14.2415 11.213 14.3636 11.3636 14.3636H11.9091C12.0597 14.3636 12.1818 14.2415 12.1818 14.0909V12.1818H14.0909C14.2415 12.1818 14.3636 12.0597 14.3636 11.9091V11.3636C14.3636 11.213 14.2415 11.0909 14.0909 11.0909H12.1818V9.18182C12.1818 9.0312 12.0597 8.90909 11.9091 8.90909H11.3636Z"
				fillRule="evenodd"
				clipRule="evenodd"
				fill="currentColor"
			/>
		</svg>
	);
}

function DocumentIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="16" height="20" viewBox="0 0 16 20" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.5 18.75C15.5 18.9801 15.3135 19.1666 15.0833 19.1666H0.916667C0.686548 19.1666 0.5 18.9801 0.5 18.75V1.24998C0.5 1.01986 0.686548 0.833313 0.916667 0.833313H10.8204C10.935 0.833313 11.0446 0.880564 11.1233 0.963937L15.3863 5.4792C15.4593 5.55654 15.5 5.65887 15.5 5.76524V18.75ZM4.25 4.99998C4.01988 4.99998 3.83333 5.18653 3.83333 5.41665V6.24998C3.83333 6.4801 4.01988 6.66665 4.25 6.66665H7.58333C7.81345 6.66665 8 6.4801 8 6.24998V5.41665C8 5.18653 7.81345 4.99998 7.58333 4.99998H4.25ZM3.83333 9.58168C3.83333 9.35157 4.01988 9.16502 4.25 9.16502H11.75C11.9801 9.16502 12.1667 9.35157 12.1667 9.58168V10.415C12.1667 10.6451 11.9801 10.8317 11.75 10.8317H4.25C4.01988 10.8317 3.83333 10.6451 3.83333 10.415V9.58168ZM4.25 13.3317C4.01988 13.3317 3.83333 13.5182 3.83333 13.7484V14.5817C3.83333 14.8118 4.01988 14.9984 4.25 14.9984H11.75C11.9801 14.9984 12.1667 14.8118 12.1667 14.5817V13.7484C12.1667 13.5182 11.9801 13.3317 11.75 13.3317H4.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function DotsIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg viewBox="0 0 24 24" fill={'currentColor'} {...props}>
			<rect x="3" y="10" width="4" height="4" rx="2" />
			<rect x="10" y="10" width="4" height="4" rx="2" />
			<rect x="17" y="10" width="4" height="4" rx="2" />
		</svg>
	);
}

function DownloadIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M17.6795 11.6164C17.5027 11.4042 17.1874 11.3756 16.9753 11.5524L13.0001 14.865L13.0001 2.5C13.0001 2.22386 12.7763 2 12.5001 2H11.5001C11.224 2 11.0001 2.22386 11.0001 2.5L11.0001 14.8659L7.02389 11.5524C6.81175 11.3756 6.49647 11.4042 6.31969 11.6164L5.6795 12.3846C5.50272 12.5967 5.53138 12.912 5.74352 13.0888L11.7435 18.0888C11.8919 18.2124 12.1073 18.2124 12.2557 18.0888L18.2557 13.0888C18.4678 12.912 18.4965 12.5967 18.3197 12.3846L17.6795 11.6164Z"
				fill="currentColor"
			/>
			<path
				d="M5.00002 22.5C5.00001 22.7761 5.22386 23 5.5 23L18.5 23.0005C18.7761 23.0005 19 22.7766 19 22.5005L19.0001 21.5005C19.0001 21.2243 18.7762 21.0005 18.5001 21.0005L5.50007 21C5.22393 21 5.00006 21.2239 5.00005 21.5L5.00002 22.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function EditBigIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
			<defs>
				<clipPath id="clip-edit-icon">
					<path d="M0 0h24v24H0z" />
				</clipPath>
			</defs>
			<path
				d="M22.011 7.908a.5.5 0 0 0 0-.707l-5.657-5.657a.5.5 0 0 0-.707 0l-2.672 2.672 6.364 6.364 2.672-2.672Zm-4.511 4.51-8.43 8.43a.5.5 0 0 1-.358.147l-5.114-.047a1 1 0 0 1-.99-.991l-.048-5.114a.5.5 0 0 1 .147-.358l8.43-8.43 6.364 6.363Z"
				fill="currentColor"
				clipPath="url(#clip-edit-icon)"
			/>
		</svg>
	);
}

function EyeIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 12C2 12 4.72727 5 12 5C17.4545 5 22 12 22 12C22 12 17.4545 19 12 19C4.72727 19 2 12 2 12ZM12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function EyeOffIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M4.21781 18.364C4.02255 18.5592 4.02255 18.8758 4.21781 19.0711L4.92492 19.7782C5.12018 19.9735 5.43676 19.9735 5.63203 19.7782L19.7742 5.63605C19.9694 5.44079 19.9694 5.12421 19.7742 4.92895L19.0671 4.22184C18.8718 4.02658 18.5552 4.02658 18.3599 4.22184L4.21781 18.364Z"
				fill="currentColor"
			/>
			<path
				d="M8.00796 11.7455C8.13392 9.7391 9.73911 8.13392 11.7455 8.00796L14.3418 5.41168C13.5888 5.15218 12.8043 5 12 5C4.72727 5 2 12 2 12C2 12 2.6792 13.7433 4.26358 15.4899L8.00796 11.7455Z"
				fill="currentColor"
			/>
			<path
				d="M9.52802 18.7105C10.286 18.8949 11.1089 19 12 19C17.4545 19 22 12 22 12C22 12 21.0079 10.4721 19.3945 8.84403L15.9926 12.2459C15.8705 14.2592 14.2592 15.8705 12.2459 15.9926L9.52802 18.7105Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ExitIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M19.4995 21H15.4995C15.3669 21 15.2397 20.9473 15.146 20.8536C15.0522 20.7598 14.9995 20.6326 14.9995 20.5V19.5C14.9995 19.3674 15.0522 19.2402 15.146 19.1464C15.2397 19.0527 15.3669 19 15.4995 19H17.9995V5H15.4995C15.3669 5 15.2397 4.94732 15.146 4.85355C15.0522 4.75979 14.9995 4.63261 14.9995 4.5V3.5C14.9995 3.36739 15.0522 3.24021 15.146 3.14645C15.2397 3.05268 15.3669 3 15.4995 3H19.4995C19.6321 3 19.7593 3.05268 19.8531 3.14645C19.9468 3.24021 19.9995 3.36739 19.9995 3.5V20.5C19.9995 20.6326 19.9468 20.7598 19.8531 20.8536C19.7593 20.9473 19.6321 21 19.4995 21Z"
				fill="currentColor"
			/>
			<path
				d="M3.99951 3.36037V20.6396C3.99951 20.7446 4.03253 20.8468 4.09389 20.932C4.15525 21.0171 4.24185 21.0808 4.3414 21.114L12.473 23.8245C12.5331 23.8445 12.5972 23.85 12.6598 23.8404C12.7225 23.8309 12.782 23.8066 12.8334 23.7695C12.8848 23.7325 12.9267 23.6837 12.9556 23.6273C12.9844 23.5709 12.9995 23.5084 12.9995 23.445V0.554995C12.9995 0.491612 12.9845 0.429135 12.9556 0.372714C12.9267 0.316293 12.8848 0.267542 12.8334 0.230479C12.782 0.193417 12.7225 0.169104 12.6598 0.159544C12.5972 0.149984 12.5332 0.155451 12.473 0.175495L4.3414 2.88599C4.24184 2.91918 4.15524 2.98286 4.09388 3.068C4.03252 3.15314 3.9995 3.25543 3.99951 3.36037ZM10.5025 13.8757L9.37826 13.5947C9.27008 13.5676 9.17405 13.5052 9.10543 13.4173C9.03681 13.3294 8.99953 13.2211 8.99953 13.1096V10.8904C8.99953 10.7789 9.03681 10.6706 9.10543 10.5827C9.17405 10.4948 9.27008 10.4324 9.37826 10.4053L10.5025 10.1242C10.5615 10.1095 10.623 10.1084 10.6825 10.121C10.742 10.1336 10.7978 10.1596 10.8457 10.197C10.8936 10.2344 10.9323 10.2823 10.959 10.3369C10.9857 10.3915 10.9995 10.4515 10.9995 10.5123V13.4877C10.9995 13.5485 10.9857 13.6085 10.959 13.6631C10.9323 13.7177 10.8936 13.7656 10.8457 13.803C10.7978 13.8404 10.742 13.8664 10.6825 13.879C10.623 13.8916 10.5615 13.8905 10.5025 13.8757H10.5025Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function FindWorkersIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M18.5 5.974 14.026 1.5 9.553 5.974l4.473 4.473L18.5 5.974Zm-17 3.579h7.158V2.395H1.5v7.158Zm8.947 8.947h7.158v-7.158h-7.158V18.5Zm-8.947 0h7.158v-7.158H1.5V18.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function FolderIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" {...props}>
			<path d="M17.501 4.18536L17.5 5.41653L2.5 5.40256V2.58325C2.5 2.30711 2.72386 2.08325 3 2.08325H7.58163C7.85777 2.08325 8.08163 2.30711 8.08163 2.58325V3.3332H17.001C17.2771 3.3332 17.501 3.55706 17.501 3.8332V4.18536Z" />
			<path d="M0.834229 7.36157L1.80579 16.6353C1.83246 16.8899 2.04709 17.0833 2.30307 17.0833H17.6981C17.9541 17.0833 18.1687 16.8899 18.1954 16.6353L19.1669 7.36157H7.57965H0.834229Z" />
		</svg>
	);
}

function HistoryIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				d="M9.99968 0.833252C8.18668 0.833252 6.4144 1.37087 4.90695 2.37811C3.3995 3.38536 2.22459 4.817 1.53078 6.49199C0.83698 8.16698 0.655449 10.0101 1.00915 11.7882C1.36284 13.5664 2.23589 15.1997 3.51787 16.4817C4.79985 17.7637 6.43319 18.6368 8.21135 18.9904C9.98951 19.3441 11.8326 19.1626 13.5076 18.4688C15.1826 17.775 16.6142 16.6001 17.6215 15.0926C18.6287 13.5852 19.1663 11.8129 19.1663 9.99992C19.1663 8.79613 18.9292 7.60414 18.4686 6.49199C18.0079 5.37984 17.3327 4.36931 16.4815 3.51811C15.6303 2.6669 14.6198 1.99169 13.5076 1.53102C12.3955 1.07035 11.2035 0.833252 9.99968 0.833252ZM12.5876 12.2257L9.39668 10.6302C9.32747 10.5956 9.26926 10.5424 9.22858 10.4766C9.1879 10.4108 9.16635 10.3349 9.16635 10.2575V3.74992C9.16635 3.63941 9.21025 3.53343 9.28839 3.45529C9.36653 3.37715 9.47251 3.33325 9.58302 3.33325H10.4164C10.5269 3.33325 10.6328 3.37715 10.711 3.45529C10.7891 3.53343 10.833 3.63941 10.833 3.74992V9.48479L13.3331 10.7348C13.382 10.7593 13.4256 10.7931 13.4615 10.8345C13.4973 10.8758 13.5247 10.9238 13.542 10.9757C13.5593 11.0276 13.5662 11.0824 13.5623 11.137C13.5585 11.1916 13.5439 11.2449 13.5194 11.2938L13.1466 12.0393C13.1222 12.0883 13.0883 12.1319 13.047 12.1678C13.0056 12.2036 12.9576 12.231 12.9057 12.2483C12.8538 12.2656 12.799 12.2725 12.7444 12.2686C12.6898 12.2647 12.6366 12.2502 12.5876 12.2257Z"
				fill="black"
			/>
		</svg>
	);
}

function InformationIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M10.9988 6.25C10.9988 6.18432 11.0117 6.11929 11.0369 6.05862C11.062 5.99795 11.0989 5.94282 11.1453 5.89639C11.1918 5.84996 11.2469 5.81314 11.3076 5.78802C11.3683 5.7629 11.4333 5.74998 11.499 5.75H12.4995C12.5652 5.74998 12.6302 5.7629 12.6909 5.78802C12.7516 5.81314 12.8067 5.84996 12.8532 5.89639C12.8996 5.94282 12.9365 5.99795 12.9616 6.05862C12.9868 6.11929 12.9997 6.18432 12.9998 6.25V12.25C12.9997 12.3826 12.947 12.5098 12.8532 12.6036C12.7594 12.6974 12.6321 12.75 12.4995 12.75H11.499C11.3664 12.75 11.2392 12.6974 11.1454 12.6036C11.0515 12.5098 10.9988 12.3826 10.9988 12.25V6.25ZM11.9993 18.25C11.7026 18.2499 11.4127 18.1618 11.1661 17.9968C10.9195 17.8319 10.7274 17.5976 10.614 17.3235C10.5006 17.0494 10.471 16.7478 10.5289 16.4569C10.5869 16.166 10.7298 15.8988 10.9396 15.6891C11.1494 15.4794 11.4167 15.3366 11.7076 15.2788C11.9986 15.2209 12.3001 15.2507 12.5742 15.3642C12.8482 15.4778 13.0825 15.6701 13.2473 15.9167C13.412 16.1634 13.5 16.4534 13.5 16.75C13.4999 17.1479 13.3417 17.5295 13.0603 17.8108C12.7789 18.0921 12.3972 18.2501 11.9993 18.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function LinkIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M16.5 11H7.5C7.22386 11 7 11.2239 7 11.5V12.5C7 12.7761 7.22386 13 7.5 13H16.5C16.7761 13 17 12.7761 17 12.5V11.5C17 11.2239 16.7761 11 16.5 11Z"
				fill="currentColor"
			/>
			<path
				d="M9.50006 16H7.17821C6.16331 16.0173 5.17773 15.6594 4.41034 14.9951C3.64295 14.3307 3.14773 13.4064 3.01959 12.3995C2.96446 11.8434 3.02632 11.282 3.20121 10.7512C3.3761 10.2205 3.66013 9.73221 4.03504 9.31783C4.40996 8.90345 4.86745 8.57212 5.3781 8.34515C5.88874 8.11819 6.44124 8.00061 7.00006 7.99999H9.50006C9.63266 7.99999 9.75984 7.94731 9.85361 7.85354C9.94738 7.75977 10.0001 7.6326 10.0001 7.49999V6.49999C10.0001 6.36738 9.94738 6.2402 9.85361 6.14643C9.75984 6.05267 9.63266 5.99999 9.50006 5.99999H7.25161C5.66104 5.97623 4.12283 6.56804 2.95836 7.65176C1.79388 8.73548 1.09325 10.2273 1.00284 11.8154C0.978135 12.6185 1.11498 13.4184 1.40525 14.1676C1.69553 14.9168 2.13332 15.6001 2.69265 16.1769C3.25199 16.7537 3.92147 17.2123 4.66139 17.5254C5.40131 17.8386 6.19659 18 7.00006 18H9.50006C9.63266 18 9.75984 17.9473 9.85361 17.8535C9.94738 17.7598 10.0001 17.6326 10.0001 17.5V16.5C10.0001 16.3674 9.94738 16.2402 9.85361 16.1464C9.75984 16.0527 9.63266 16 9.50006 16Z"
				fill="currentColor"
			/>
			<path
				d="M16.7484 5.99999H14.5C14.3674 5.99999 14.2402 6.05267 14.1464 6.14643C14.0527 6.2402 14 6.36738 14 6.49999V7.49999C14 7.6326 14.0527 7.75977 14.1464 7.85354C14.2402 7.94731 14.3674 7.99999 14.5 7.99999H16.8219C17.8368 7.98269 18.8223 8.34053 19.5897 9.00492C20.3571 9.66931 20.8523 10.5935 20.9805 11.6004C21.0356 12.1565 20.9737 12.718 20.7989 13.2487C20.624 13.7795 20.3399 14.2678 19.965 14.6821C19.5901 15.0965 19.1326 15.4279 18.622 15.6548C18.1113 15.8818 17.5588 15.9994 17 16H14.5C14.3674 16 14.2402 16.0527 14.1464 16.1464C14.0527 16.2402 14 16.3674 14 16.5V17.5C14 17.6326 14.0527 17.7598 14.1464 17.8535C14.2402 17.9473 14.3674 18 14.5 18H17C17.8035 18 18.5987 17.8386 19.3387 17.5254C20.0786 17.2123 20.7481 16.7537 21.3074 16.1769C21.8667 15.6001 22.3045 14.9168 22.5948 14.1676C22.8851 13.4184 23.0219 12.6185 22.9972 11.8154C22.9068 10.2273 22.2062 8.73548 21.0417 7.65176C19.8772 6.56804 18.339 5.97623 16.7484 5.99999Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function LoadingIcon({className, ...restProps}: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg
			className={cn(className, styles.loading, styles.animatableRotate)}
			x="0"
			y="0"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			{...restProps}
		>
			<circle cx="12" cy="12" r="10.5" stroke="currentColor" fill="none" strokeWidth="1.5" />
		</svg>
	);
}

function MinusMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M5.122 9.289a.417.417 0 0 1 .295-.122h9.166a.417.417 0 0 1 .417.416v.834a.417.417 0 0 1-.417.416H5.417A.417.417 0 0 1 5 10.417v-.834c0-.11.044-.216.122-.294Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function PayIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path d="M5.5 6C5.22386 6 5 6.22386 5 6.5V9H19V6.5C19 6.22386 18.7761 6 18.5 6H5.5Z" fill="currentColor" />
			<path d="M19 11H5V17.5C5 17.7761 5.22386 18 5.5 18H18.5C18.7761 18 19 17.7761 19 17.5V11Z" fill="currentColor" />
		</svg>
	);
}

function PhoneIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M2.119 7.808a18.41 18.41 0 0 0 4.984 9.089 18.41 18.41 0 0 0 9.089 4.984 4.452 4.452 0 0 0 5.136-3.049l.513-1.604-4.98-2.49-2.386 2.385a15.118 15.118 0 0 1-4.544-3.055 15.118 15.118 0 0 1-3.055-4.544l2.385-2.385-2.49-4.98-1.604.513A4.452 4.452 0 0 0 2.12 7.808Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function PlusIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M11.5 5C11.2239 5 11 5.22386 11 5.5V11H5.5C5.22386 11 5 11.2239 5 11.5V12.5C5 12.7761 5.22386 13 5.5 13H11V18.5C11 18.7761 11.2239 19 11.5 19H12.5C12.7761 19 13 18.7761 13 18.5V13H18.5C18.7761 13 19 12.7761 19 12.5V11.5C19 11.2239 18.7761 11 18.5 11H13V5.5C13 5.22386 12.7761 5 12.5 5H11.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function PlusMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				d="M10.8333 9.16667V5.41667C10.8333 5.30616 10.7894 5.20018 10.7113 5.12204C10.6332 5.0439 10.5272 5 10.4167 5H9.58333C9.47283 5 9.36685 5.0439 9.2887 5.12204C9.21057 5.20018 9.16667 5.30616 9.16667 5.41667V9.16667H5.41667C5.30616 9.16667 5.20018 9.21057 5.12204 9.2887C5.0439 9.36685 5 9.47283 5 9.58333V10.4167C5 10.5272 5.0439 10.6332 5.12204 10.7113C5.20018 10.7894 5.30616 10.8333 5.41667 10.8333H9.16667V14.5833C9.16667 14.6938 9.21057 14.7998 9.2887 14.878C9.36685 14.9561 9.47283 15 9.58333 15H10.4167C10.5272 15 10.6332 14.9561 10.7113 14.878C10.7894 14.7998 10.8333 14.6938 10.8333 14.5833V10.8333H14.5833C14.6938 10.8333 14.7998 10.7894 14.878 10.7113C14.9561 10.6332 15 10.5272 15 10.4167V9.58333C15 9.47283 14.9561 9.36685 14.878 9.2887C14.7998 9.21057 14.6938 9.16667 14.5833 9.16667H10.8333Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ProfileIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM12 12.0096C11.4399 12.0096 10.898 11.8109 10.4706 11.4489C10.0433 11.0869 9.75816 10.5851 9.66604 10.0326L9.48808 8.96545C9.42725 8.60062 9.44661 8.22692 9.54483 7.87034C9.64304 7.51375 9.81776 7.18284 10.0568 6.90062C10.2959 6.61839 10.5935 6.39163 10.9291 6.2361C11.2647 6.08057 11.6301 6 12 6C12.3698 6 12.7353 6.08057 13.0708 6.2361C13.4064 6.39163 13.7041 6.6184 13.9431 6.90062C14.1822 7.18285 14.3569 7.51376 14.4551 7.87035C14.5533 8.22694 14.5727 8.60064 14.5119 8.96546L14.3339 10.0327C14.2418 10.5851 13.9567 11.087 13.5293 11.4489C13.102 11.8109 12.56 12.0096 12 12.0096ZM15.9984 17.5184H8.0016C7.86918 17.5184 7.73807 17.4921 7.61586 17.4411C7.49365 17.3901 7.38277 17.3154 7.28963 17.2213C7.19649 17.1271 7.12294 17.0155 7.07323 16.8927C7.02353 16.77 6.99866 16.6386 7.00006 16.5062L7.01084 15.4869C7.0134 15.0713 7.12288 14.6633 7.32872 14.3022C7.53457 13.9412 7.82987 13.6392 8.18621 13.4253C8.60813 13.177 9.08454 13.036 9.57365 13.0146C9.66871 13.0112 9.7633 13.0297 9.85012 13.0685C10.5278 13.3662 11.2599 13.5199 12 13.5199C12.7401 13.5199 13.4722 13.3662 14.1499 13.0685C14.2367 13.0297 14.3313 13.0112 14.4264 13.0146C14.9155 13.036 15.3919 13.177 15.8138 13.4253C16.1702 13.6392 16.4654 13.9412 16.6713 14.3023C16.8771 14.6633 16.9866 15.0713 16.9892 15.4869L17 16.5062C17.0014 16.6386 16.9765 16.77 16.9268 16.8927C16.8771 17.0155 16.8035 17.1271 16.7104 17.2213C16.6172 17.3154 16.5064 17.3901 16.3842 17.4411C16.262 17.4921 16.1309 17.5184 15.9984 17.5184Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ReceiptIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M20.5 1H3.5C3.36739 1 3.24021 1.05268 3.14645 1.14645C3.05268 1.24021 3 1.36739 3 1.5V22.6798C3 22.7083 3.00813 22.7362 3.02343 22.7602C3.03873 22.7843 3.06056 22.8035 3.08637 22.8156C3.11219 22.8277 3.14091 22.8321 3.16918 22.8285C3.19745 22.8248 3.2241 22.8132 3.246 22.795L6 20.5L8.67993 22.7332C8.76977 22.8081 8.88304 22.8491 9 22.8491C9.11696 22.8491 9.23023 22.8081 9.32007 22.7332L12 20.5L14.6799 22.7332C14.7698 22.8081 14.883 22.8491 15 22.8491C15.117 22.8491 15.2302 22.8081 15.3201 22.7332L18 20.5L20.754 22.795C20.7759 22.8132 20.8026 22.8249 20.8308 22.8285C20.8591 22.8322 20.8878 22.8277 20.9136 22.8156C20.9395 22.8035 20.9613 22.7843 20.9766 22.7602C20.9919 22.7362 21 22.7083 21 22.6798V1.5C21 1.36739 20.9473 1.24021 20.8536 1.14645C20.7598 1.05268 20.6326 1 20.5 1ZM17 16.5C17 16.6326 16.9473 16.7598 16.8536 16.8536C16.7598 16.9473 16.6326 17 16.5 17H13.5C13.3674 17 13.2402 16.9473 13.1464 16.8536C13.0527 16.7598 13 16.6326 13 16.5V15.5C13 15.3674 13.0527 15.2402 13.1464 15.1464C13.2402 15.0527 13.3674 15 13.5 15H16.5C16.6326 15 16.7598 15.0527 16.8536 15.1464C16.9473 15.2402 17 15.3674 17 15.5V16.5ZM17 11.5C17 11.6326 16.9473 11.7598 16.8536 11.8536C16.7598 11.9473 16.6326 12 16.5 12H7.5C7.36739 12 7.24021 11.9473 7.14645 11.8536C7.05268 11.7598 7 11.6326 7 11.5V10.5C7 10.3674 7.05268 10.2402 7.14645 10.1464C7.24021 10.0527 7.36739 10 7.5 10H16.5C16.6326 10 16.7598 10.0527 16.8536 10.1464C16.9473 10.2402 17 10.3674 17 10.5V11.5ZM17 6.5C17 6.63261 16.9473 6.75979 16.8536 6.85355C16.7598 6.94732 16.6326 7 16.5 7H7.5C7.36739 7 7.24021 6.94732 7.14645 6.85355C7.05268 6.75979 7 6.63261 7 6.5V5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5H16.5C16.6326 5 16.7598 5.05268 16.8536 5.14645C16.9473 5.24021 17 5.36739 17 5.5V6.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function RecoverIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M7.09551 5.01057C7.04555 4.93535 6.97615 4.87507 6.89469 4.83613C6.81322 4.79718 6.72273 4.78103 6.63282 4.78937C6.54291 4.79772 6.45694 4.83026 6.38403 4.88353C6.31113 4.93681 6.25401 5.00883 6.21874 5.09195L4.36185 9.46897C4.336 9.52989 4.32567 9.59627 4.33179 9.66216C4.3379 9.72805 4.36027 9.79139 4.39688 9.84651C4.4335 9.90163 4.48321 9.94681 4.54158 9.97799C4.59994 10.0092 4.66513 10.0254 4.7313 10.0252L9.4859 10.0106C9.5762 10.0104 9.66474 9.98563 9.74211 9.93908C9.81949 9.89253 9.88282 9.8259 9.92537 9.74626C9.96792 9.66661 9.98812 9.57693 9.9838 9.48674C9.97949 9.39654 9.95083 9.3092 9.90087 9.23398L9.05414 7.95925C9.74898 7.45493 10.566 7.13535 11.4281 7.0378C12.5569 6.91007 13.6955 7.17067 14.6563 7.77666C15.6172 8.38265 16.343 9.29787 16.7141 10.3715C17.0852 11.4452 17.0795 12.6133 16.6979 13.6832C16.3163 14.7532 15.5816 15.6613 14.6149 16.2579C13.6481 16.8544 12.507 17.1039 11.3795 16.9651C10.2521 16.8264 9.20547 16.3077 8.41223 15.4945C7.79639 14.8632 7.36177 14.0837 7.14634 13.2375C7.11105 13.0989 6.98858 12.998 6.84555 12.9985L5.52408 13.0022C5.28092 13.0029 5.09382 13.219 5.14425 13.4568C5.30742 14.2264 5.59969 14.9655 6.01095 15.6419C6.5998 16.6103 7.41499 17.4213 8.38646 18.0051C9.35793 18.5889 10.4566 18.9281 11.5881 18.9935C12.7196 19.0589 13.8501 18.8486 14.8824 18.3806C15.9147 17.9127 16.8179 17.2011 17.5144 16.307C18.2109 15.4129 18.68 14.363 18.8812 13.2476C19.0823 12.1322 19.0097 10.9847 18.6694 9.90354C18.3292 8.82242 17.7315 7.84009 16.9278 7.04097C16.276 6.39267 15.5029 5.87914 14.6526 5.5297C13.8023 5.18026 12.8915 5.00176 11.9722 5.0044C11.0529 5.00704 10.1432 5.19076 9.2949 5.54508C8.81825 5.74417 8.36627 5.99492 7.94676 6.2921L7.09551 5.01057Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function TrashIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...props}>
			<path
				d="M10.1 2.70001C10.1 2.42387 10.3239 2.20001 10.6 2.20001H13.4C13.6761 2.20001 13.9 2.42387 13.9 2.70001V3.8H20C20.2761 3.8 20.5 4.02386 20.5 4.3V5.5C20.5 5.77615 20.2761 6 20 6H4C3.72386 6 3.5 5.77615 3.5 5.5V4.3C3.5 4.02386 3.72386 3.8 4 3.8H10.1V2.70001Z"
				fill="currentColor"
			/>
			<path
				d="M5.53783 7.79999H18.4622C18.7527 7.79999 18.982 8.04668 18.9608 8.33639L18.0338 21.0364C18.0148 21.2977 17.7972 21.5 17.5352 21.5H6.46483C6.20281 21.5 5.98524 21.2977 5.96616 21.0364L5.03915 8.33639C5.01801 8.04668 5.24735 7.79999 5.53783 7.79999Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function RemoveIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<g>
				<path
					d="M21.5 2H14V0.5C14 0.367392 13.9473 0.240215 13.8536 0.146447C13.7598 0.0526784 13.6326 0 13.5 0L10.5 0C10.3674 0 10.2402 0.0526784 10.1464 0.146447C10.0527 0.240215 10 0.367392 10 0.5V2H2.5C2.36739 2 2.24021 2.05268 2.14645 2.14645C2.05268 2.24021 2 2.36739 2 2.5V4.5C2 4.63261 2.05268 4.75979 2.14645 4.85355C2.24021 4.94732 2.36739 5 2.5 5H21.5C21.6326 5 21.7598 4.94732 21.8536 4.85355C21.9473 4.75979 22 4.63261 22 4.5V2.5C22 2.36739 21.9473 2.24021 21.8536 2.14645C21.7598 2.05268 21.6326 2 21.5 2Z"
					fill="currentColor"
				/>
				<path
					d="M19.4676 7H4.53204C4.46375 7 4.39618 7.01399 4.33351 7.0411C4.27083 7.06821 4.21437 7.10788 4.16761 7.15765C4.12084 7.20742 4.08477 7.26624 4.06161 7.33048C4.03846 7.39472 4.0287 7.46303 4.03295 7.53119L4.97045 22.5312C4.97841 22.6582 5.03445 22.7773 5.12717 22.8644C5.2199 22.9515 5.34233 23 5.46954 23H18.5301C18.6573 23 18.7797 22.9515 18.8724 22.8644C18.9652 22.7773 19.0212 22.6582 19.0292 22.5312L19.9667 7.53119C19.9709 7.46303 19.9612 7.39472 19.938 7.33048C19.9148 7.26624 19.8788 7.20742 19.832 7.15765C19.7853 7.10788 19.7288 7.06821 19.6661 7.0411C19.6034 7.01399 19.5359 7 19.4676 7ZM9.96746 20H8.97424C8.84597 20 8.72261 19.9507 8.62967 19.8623C8.53673 19.7739 8.48133 19.6531 8.47491 19.525L8.02471 10.525C8.02132 10.4573 8.03173 10.3897 8.0553 10.3261C8.07886 10.2626 8.1151 10.2045 8.16181 10.1554C8.20851 10.1063 8.26471 10.0672 8.32699 10.0405C8.38927 10.0138 8.45633 10 8.5241 10H9.51733C9.6456 10 9.76897 10.0493 9.8619 10.1377C9.95484 10.2261 10.0102 10.3469 10.0167 10.475L10.4669 19.475C10.4702 19.5427 10.4598 19.6103 10.4363 19.6739C10.4127 19.7374 10.3765 19.7955 10.3298 19.8446C10.283 19.8937 10.2268 19.9328 10.1646 19.9595C10.1023 19.9862 10.0352 20 9.96746 20ZM15.5247 19.525C15.5183 19.6531 15.4629 19.7739 15.37 19.8623C15.277 19.9507 15.1537 20 15.0254 20H14.0241C13.9563 20 13.8893 19.9862 13.827 19.9595C13.7647 19.9328 13.7085 19.8937 13.6618 19.8446C13.6151 19.7955 13.5789 19.7374 13.5553 19.6739C13.5317 19.6103 13.5213 19.5427 13.5247 19.475L13.9749 10.475C13.9813 10.3469 14.0367 10.2261 14.1297 10.1377C14.2226 10.0493 14.346 10 14.4742 10H15.4755C15.5433 10 15.6103 10.0138 15.6726 10.0405C15.7349 10.0672 15.7911 10.1063 15.8378 10.1554C15.8845 10.2045 15.9208 10.2626 15.9443 10.3261C15.9679 10.3897 15.9783 10.4573 15.9749 10.525L15.5247 19.525Z"
					fill="currentColor"
				/>
			</g>
		</svg>
	);
}

function RemoveMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M13.981 7.478H6.02a.499.499 0 0 0-.508.525l.572 7.543c.02.256.242.454.509.454h6.817a.502.502 0 0 0 .508-.454l.573-7.543a.498.498 0 0 0-.509-.525ZM9.28 4a.5.5 0 0 0-.51.49v.506H5.01a.5.5 0 0 0-.51.49v.388a.5.5 0 0 0 .51.49h9.98a.5.5 0 0 0 .51-.49v-.388a.5.5 0 0 0-.51-.49h-3.76V4.49a.5.5 0 0 0-.51-.49H9.28Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function SignatureIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M6.03209 22.6784C5.84439 22.6782 5.65698 22.6635 5.47154 22.6345C3.36705 22.3034 2.06431 19.8288 2.50572 16.9997C3.01695 13.7234 5.86172 10.3674 12.0726 9.84787C12.6244 6.86687 12.62 4.25119 11.9305 3.41672C11.6623 3.21621 11.3491 3.08455 11.0182 3.0333C10.6873 2.98205 10.3488 3.01277 10.0326 3.12277C9.31406 3.28515 6.95679 4.10069 5.84257 7.87506C5.80792 8 5.72626 8.10668 5.61469 8.17273C5.50313 8.23878 5.37032 8.25908 5.24412 8.22937L4.27359 7.98551C4.20827 7.96914 4.14689 7.93985 4.09307 7.89939C4.03924 7.85892 3.99406 7.8081 3.96019 7.7499C3.92631 7.6917 3.90443 7.62731 3.89582 7.56053C3.88721 7.49374 3.89206 7.42591 3.91008 7.36102C4.87739 4.06071 6.97505 1.7633 9.59166 1.1716C10.2654 0.963752 10.9833 0.944332 11.6673 1.11545C12.3513 1.28656 13.0348 1.61308 13.472 2.1423C14.5795 3.48264 14.679 6.49338 14.1254 9.78098C15.4195 9.80596 16.7104 9.92065 17.9886 10.1242C18.2017 10.1557 18.4061 10.2309 18.5887 10.3451C18.7714 10.4593 18.9285 10.61 19.0501 10.7878C19.1883 10.999 19.2819 11.2361 19.3254 11.4847C19.3689 11.7333 19.3613 11.9881 19.3031 12.2336C18.9943 13.4448 18.6128 14.6363 18.1605 15.8015C17.6451 17.0476 17.2621 18.3444 17.0179 19.6706C18.1665 19.2027 19.2362 18.5607 20.1895 17.7672C20.2956 17.69 20.4279 17.6575 20.5577 17.6769C20.6876 17.6964 20.8046 17.766 20.8834 17.871L21.4802 18.6833C21.5577 18.7915 21.5892 18.9259 21.5679 19.0573C21.5466 19.1886 21.4741 19.3062 21.3664 19.3843C18.8946 21.174 17.392 21.9945 16.2181 21.5896C15.9435 21.4903 15.6978 21.3242 15.5033 21.1063C15.3088 20.8885 15.1715 20.6257 15.1039 20.3416C14.808 19.2849 15.3578 17.6697 16.2796 15.1209C16.6732 14.034 17.0795 12.9124 17.2943 12.0432C16.1093 11.8735 14.9142 11.7851 13.7171 11.7786C13.1679 14.1693 12.2966 16.4743 11.1273 18.6306C9.27671 21.8786 7.41539 22.6784 6.03209 22.6784ZM11.6151 11.906C6.98179 12.4817 4.85582 14.9099 4.48179 17.3073C4.19957 19.1179 4.94029 20.5261 5.78209 20.6579C7.2938 20.9177 8.6898 18.8689 9.38951 17.6404C10.3733 15.8318 11.1212 13.9047 11.6151 11.906Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function SignatureMiniIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.87911 3.87064C9.48722 3.76669 9.07594 3.77775 8.68978 3.90243C7.23178 4.25582 6.10074 5.60294 5.58522 7.46787L5.58453 7.47049C5.56872 7.53087 5.5645 7.5938 5.57202 7.65572C5.57955 7.71765 5.59873 7.77781 5.62885 7.83267C5.65898 7.88755 5.6996 7.93629 5.74888 7.97557C5.79818 8.01487 5.85509 8.04383 5.91641 8.06013L6.42298 8.19512L6.42604 8.19588C6.54547 8.22569 6.6706 8.20495 6.77427 8.13987C6.87696 8.07541 6.94927 7.97358 6.97994 7.85804C7.5396 5.84958 8.70625 5.44501 9.02099 5.36959L9.03249 5.36684L9.04358 5.36275C9.17642 5.31376 9.3181 5.3002 9.45653 5.32293C9.58698 5.34435 9.71176 5.39756 9.82103 5.47917C9.87834 5.56167 9.93259 5.69814 9.97326 5.89696C10.0163 6.10739 10.0407 6.37004 10.0454 6.67526C10.0541 7.24786 9.99322 7.95384 9.86786 8.71347C6.64723 9.05326 5.12418 10.9438 4.84696 12.8275C4.72665 13.6451 4.84233 14.4211 5.14145 15.0236C5.44062 15.6263 5.93206 16.0682 6.56046 16.173C6.66799 16.1909 6.77696 16.1999 6.88585 16.2C7.70944 16.2 8.73661 15.6881 9.72212 13.8541L9.72398 13.8505C10.3178 12.6894 10.7662 11.4516 11.058 10.1684C11.546 10.1774 12.0332 10.2145 12.5174 10.2795C12.4012 10.7131 12.2233 11.2344 12.0465 11.752C11.8066 12.4554 11.6111 13.041 11.4959 13.525C11.3819 14.0037 11.3385 14.4126 11.4277 14.754C11.4701 14.9404 11.5556 15.1139 11.6775 15.2586C11.8003 15.4044 11.9562 15.5167 12.1321 15.5841L12.135 15.5851C12.5155 15.7243 12.9258 15.6419 13.3804 15.4226C13.8347 15.2035 14.3677 14.8308 15.0133 14.3351C15.1121 14.2592 15.1757 14.1474 15.1943 14.0258C15.2129 13.9044 15.1858 13.779 15.1166 13.6766L14.8037 13.225L14.8025 13.2232C14.7314 13.1231 14.6237 13.0535 14.5006 13.034C14.3772 13.0144 14.2526 13.0472 14.1545 13.1228L14.1447 13.1315C13.7609 13.4702 13.34 13.7572 12.8917 13.9866C13.0154 13.3987 13.1869 12.823 13.4041 12.266L13.4056 12.2621C13.6443 11.6099 13.8458 10.943 14.0087 10.2651L14.0094 10.262C14.0454 10.101 14.0501 9.9341 14.0232 9.77124C13.9964 9.60837 13.9384 9.45244 13.8525 9.31303L13.8503 9.3096C13.7722 9.18857 13.6707 9.0851 13.5518 9.00628C13.4332 8.92766 13.2999 8.87539 13.1602 8.85333C12.5585 8.75177 11.9515 8.68964 11.3427 8.66727C11.4639 7.82824 11.5116 7.02334 11.4653 6.32903C11.4154 5.58055 11.2545 4.92865 10.9278 4.50943C10.6631 4.16973 10.2604 3.97177 9.87911 3.87064ZM6.38129 14.2275C6.26299 13.935 6.20526 13.526 6.27439 13.0558C6.4468 11.884 7.39494 10.6532 9.5354 10.2795C9.28287 11.2666 8.92254 12.2193 8.46161 13.118C8.28168 13.4528 8.01812 13.8876 7.70966 14.2188C7.39139 14.5605 7.07782 14.7368 6.79122 14.6846L6.78813 14.684C6.67087 14.6646 6.50448 14.532 6.38129 14.2275Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function RepeatIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.9308 14.726L20.7001 10.3129C20.7337 10.2291 20.744 10.1377 20.7298 10.0485C20.7157 9.95936 20.6777 9.87567 20.6198 9.80636C20.5619 9.73706 20.4864 9.68472 20.4011 9.6549C20.3159 9.62508 20.2242 9.61889 20.1357 9.637L18.6749 9.936C18.3215 8.78931 17.6791 7.75278 16.8095 6.92604C15.9399 6.0993 14.8722 5.51013 13.7091 5.21516C12.546 4.92019 11.3266 4.92934 10.1681 5.24172C9.00957 5.5541 7.95087 6.15922 7.09374 6.99892C7.00153 7.0936 6.95063 7.22098 6.95218 7.35313C6.95374 7.48528 7.00762 7.61143 7.10203 7.70392L7.88139 8.48329C7.91952 8.52047 7.96467 8.54969 8.01421 8.56924C8.06376 8.58879 8.11669 8.59828 8.16994 8.59717C8.22319 8.59605 8.27568 8.58434 8.32436 8.56273C8.37304 8.54112 8.41693 8.51003 8.45347 8.47129C9.0497 7.87211 9.78833 7.43416 10.6001 7.1985C11.4119 6.96285 12.2702 6.9372 13.0946 7.12397C13.919 7.31075 14.6824 7.70382 15.3134 8.26633C15.9443 8.82884 16.4221 9.54237 16.7018 10.34L15.1686 10.6539C15.0801 10.672 14.9982 10.7138 14.9316 10.7747C14.8649 10.8356 14.816 10.9134 14.79 10.9999C14.764 11.0864 14.762 11.1783 14.784 11.2659C14.8061 11.3534 14.8514 11.4334 14.9153 11.4973L18.2766 14.8599C18.3234 14.9067 18.3811 14.9412 18.4444 14.9602C18.5078 14.9793 18.5749 14.9823 18.6398 14.969C18.7046 14.9557 18.7651 14.9266 18.8159 14.8842C18.8667 14.8418 18.9062 14.7874 18.9308 14.726ZM3.25665 13.953C3.24252 13.8638 3.2528 13.7725 3.2864 13.6886L5.05581 9.27544C5.08044 9.21402 5.11991 9.15967 5.17071 9.11726C5.2215 9.07484 5.28202 9.0457 5.34685 9.03242C5.41168 9.01915 5.47879 9.02217 5.54216 9.0412C5.60554 9.06024 5.6632 9.0947 5.70998 9.1415C5.70998 9.1415 7.94806 11.3637 9.08622 12.5029C9.14994 12.5668 9.19515 12.6467 9.21703 12.7343C9.23891 12.8218 9.23665 12.9136 9.21049 13C9.18433 13.0863 9.13524 13.164 9.06845 13.2246C9.00167 13.2853 8.91968 13.3267 8.83122 13.3445L7.2846 13.6613C7.56441 14.4592 8.04232 15.1729 8.67348 15.7355C9.30465 16.2981 10.0684 16.6911 10.893 16.8777C11.7177 17.0643 12.5762 17.0384 13.3881 16.8023C14.2 16.5663 14.9386 16.1279 15.5347 15.5282C15.5712 15.4894 15.6151 15.4583 15.6638 15.4367C15.7124 15.415 15.7649 15.4033 15.8182 15.4022C15.8715 15.4011 15.9244 15.4106 15.974 15.4301C16.0235 15.4497 16.0687 15.4789 16.1068 15.5161L16.8861 16.2954C16.9805 16.3878 17.0344 16.514 17.0359 16.6461C17.0375 16.7782 16.9867 16.9056 16.8945 17.0003C16.0376 17.8405 14.979 18.4462 13.8203 18.7591C12.6617 19.0719 11.442 19.0814 10.2786 18.7867C9.11526 18.4919 8.04728 17.9028 7.17741 17.0759C6.30753 16.2491 5.665 15.2124 5.31161 14.0654L3.85079 14.3646C3.76233 14.3827 3.67061 14.3765 3.58537 14.3467C3.50014 14.3168 3.42457 14.2645 3.36669 14.1952C3.30882 14.1259 3.27079 14.0422 3.25665 13.953Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function WalletIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M21 6H5C4.73478 6 4.48043 5.89464 4.29289 5.70711C4.10536 5.51957 4 5.26522 4 5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H19.5C19.6326 4 19.7598 3.94732 19.8536 3.85355C19.9473 3.75979 20 3.63261 20 3.5V2.5C20 2.36739 19.9473 2.24021 19.8536 2.14645C19.7598 2.05268 19.6326 2 19.5 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V20C2 20.2652 2.10536 20.5196 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5196 22 20.2652 22 20V7C22 6.73478 21.8946 6.48043 21.7071 6.29289C21.5196 6.10536 21.2652 6 21 6ZM17.5 15C17.2033 15 16.9133 14.912 16.6666 14.7472C16.42 14.5824 16.2277 14.3481 16.1142 14.074C16.0007 13.7999 15.9709 13.4983 16.0288 13.2074C16.0867 12.9164 16.2296 12.6491 16.4393 12.4393C16.6491 12.2296 16.9164 12.0867 17.2074 12.0288C17.4983 11.9709 17.7999 12.0006 18.074 12.1142C18.3481 12.2277 18.5824 12.42 18.7472 12.6666C18.912 12.9133 19 13.2033 19 13.5C19 13.8978 18.842 14.2794 18.5607 14.5607C18.2794 14.842 17.8978 15 17.5 15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function WarningIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M23.8585 20.4895L12.8605 1.97014C12.7718 1.82094 12.6459 1.69736 12.4951 1.61152C12.3442 1.52569 12.1737 1.48056 12.0001 1.48056C11.8266 1.48056 11.656 1.52569 11.5052 1.61152C11.3544 1.69736 11.2284 1.82094 11.1398 1.97014L0.141796 20.4895C0.0516536 20.6414 0.00333358 20.8144 0.00174924 20.991C0.000164902 21.1676 0.0453727 21.3415 0.132776 21.4949C0.220179 21.6484 0.346659 21.7759 0.499356 21.8646C0.652052 21.9534 0.825519 22.0001 1.00212 22H22.9981C23.1747 22.0001 23.3482 21.9534 23.5009 21.8647C23.6536 21.7759 23.7801 21.6484 23.8675 21.4949C23.9549 21.3415 24.0001 21.1676 23.9985 20.991C23.9969 20.8144 23.9486 20.6414 23.8585 20.4895ZM11.0055 7.49999C11.0055 7.43431 11.0185 7.36928 11.0436 7.30861C11.0688 7.24794 11.1056 7.19281 11.1521 7.14638C11.1985 7.09995 11.2537 7.06313 11.3143 7.03801C11.375 7.01289 11.4401 6.99997 11.5057 6.99999H12.5062C12.5719 6.99997 12.6369 7.01289 12.6976 7.03801C12.7583 7.06313 12.8135 7.09995 12.8599 7.14638C12.9064 7.19281 12.9432 7.24794 12.9684 7.30861C12.9935 7.36928 13.0065 7.43431 13.0065 7.49999V13.5C13.0064 13.6326 12.9537 13.7598 12.8599 13.8536C12.7661 13.9474 12.6389 14 12.5062 14H11.5057C11.3731 14 11.2459 13.9474 11.1521 13.8536C11.0583 13.7598 11.0055 13.6326 11.0055 13.5V7.49999ZM12.006 19.5C11.7094 19.4998 11.4194 19.4117 11.1728 19.2468C10.9263 19.0819 10.7341 18.8476 10.6207 18.5735C10.5073 18.2994 10.4777 17.9978 10.5356 17.7069C10.5936 17.416 10.7365 17.1488 10.9463 16.9391C11.1561 16.7294 11.4234 16.5866 11.7144 16.5288C12.0053 16.4709 12.3069 16.5007 12.5809 16.6142C12.855 16.7278 13.0892 16.92 13.254 17.1667C13.4188 17.4134 13.5067 17.7033 13.5067 18C13.5066 18.3979 13.3485 18.7795 13.067 19.0608C12.7856 19.3421 12.4039 19.5001 12.006 19.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function RegistryIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="22" viewBox="0 0 20 22" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.3335 2.07143C1.05735 2.07143 0.833496 2.29528 0.833496 2.57143V9.60714C0.833496 9.88328 1.05735 10.1071 1.3335 10.1071H18.6668C18.943 10.1071 19.1668 9.88328 19.1668 9.60714V2.57143C19.1668 2.29528 18.943 2.07143 18.6668 2.07143H1.3335ZM8.8335 4.75C8.55735 4.75 8.3335 4.97386 8.3335 5.25V6.03571C8.3335 6.31185 8.55735 6.53571 8.8335 6.53571H11.1668C11.443 6.53571 11.6668 6.31185 11.6668 6.03571V5.25C11.6668 4.97386 11.443 4.75 11.1668 4.75H8.8335Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.3335 11.8928C1.05735 11.8928 0.833496 12.1167 0.833496 12.3928V19.4286C0.833496 19.7047 1.05735 19.9286 1.3335 19.9286H18.6668C18.943 19.9286 19.1668 19.7047 19.1668 19.4286V12.3928C19.1668 12.1167 18.943 11.8928 18.6668 11.8928H1.3335ZM8.8335 14.5714C8.55735 14.5714 8.3335 14.7953 8.3335 15.0714V15.8571C8.3335 16.1333 8.55735 16.3571 8.8335 16.3571H11.1668C11.443 16.3571 11.6668 16.1333 11.6668 15.8571V15.0714C11.6668 14.7953 11.443 14.5714 11.1668 14.5714H8.8335Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ErrorIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M9.166 5.208a.417.417 0 0 1 .417-.416h.833a.417.417 0 0 1 .417.416v5a.417.417 0 0 1-.417.417h-.833a.417.417 0 0 1-.417-.417v-5Zm.833 10A1.25 1.25 0 1 1 10 12.71a1.25 1.25 0 0 1 0 2.498Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function ErrorCircleIcon(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.0002 19.1667C15.0628 19.1667 19.1668 15.0626 19.1668 9.99999C19.1668 4.93738 15.0628 0.833328 10.0002 0.833328C4.93755 0.833328 0.833496 4.93738 0.833496 9.99999C0.833496 15.0626 4.93755 19.1667 10.0002 19.1667ZM9.19757 5.04884C9.17662 5.0994 9.16582 5.1536 9.16581 5.20833V10.2083C9.16584 10.3189 9.20978 10.4249 9.28796 10.503C9.36613 10.5811 9.47215 10.625 9.58268 10.625H10.4164C10.527 10.625 10.633 10.5811 10.7111 10.503C10.7893 10.4249 10.8333 10.3189 10.8333 10.2083V5.20833C10.8333 5.1536 10.8225 5.0994 10.8015 5.04884C10.7806 4.99829 10.7499 4.95235 10.7112 4.91366C10.6724 4.87496 10.6265 4.84428 10.5759 4.82335C10.5253 4.80241 10.4712 4.79165 10.4164 4.79166H9.58268C9.52795 4.79165 9.47375 4.80241 9.42318 4.82335C9.37261 4.84428 9.32666 4.87496 9.28795 4.91366C9.24924 4.95235 9.21853 4.99829 9.19757 5.04884ZM9.30526 14.9974C9.51074 15.1348 9.75235 15.2082 9.99955 15.2083C10.3312 15.2084 10.6492 15.0768 10.8837 14.8423C11.1183 14.6079 11.2501 14.2899 11.2502 13.9583C11.2502 13.7111 11.1769 13.4695 11.0395 13.2639C10.9022 13.0584 10.707 12.8982 10.4787 12.8035C10.2503 12.7089 9.99898 12.6841 9.75652 12.7323C9.51406 12.7805 9.29133 12.8995 9.11649 13.0742C8.94165 13.249 8.82256 13.4717 8.77425 13.7141C8.72596 13.9565 8.75062 14.2078 8.84514 14.4363C8.93965 14.6647 9.09978 14.8599 9.30526 14.9974Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function SafeIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" {...props}>
			<path
				d="M6 16.823a1 1 0 0 0-1 1V22a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4.177a1 1 0 0 0-1-1H6Zm10 0a1 1 0 0 0-1 1V22a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-4.177a1 1 0 0 0-1-1h-2Z"
				fill="currentColor"
			/>
			<path
				d="M3 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Zm17 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function SearchIcon(props: React.SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" {...props}>
			<path
				d="M15.3781 14.1719L11.0094 9.80327C11.8937 8.62169 12.2974 7.14902 12.1395 5.6817C11.9816 4.21437 11.2736 2.86136 10.1582 1.89501C9.04282 0.928655 7.60275 0.420723 6.12789 0.473457C4.65304 0.526191 3.25292 1.13568 2.20937 2.17922C1.16583 3.22277 0.556343 4.62289 0.503609 6.09774C0.450874 7.5726 0.958806 9.01267 1.92516 10.1281C2.89151 11.2435 4.24453 11.9514 5.71185 12.1094C7.17917 12.2673 8.65184 11.8635 9.83342 10.9793L14.2021 15.3479C14.2407 15.3865 14.2865 15.4172 14.337 15.4381C14.3874 15.459 14.4415 15.4697 14.4961 15.4697C14.5507 15.4697 14.6048 15.459 14.6552 15.4381C14.7057 15.4172 14.7515 15.3865 14.7901 15.3479L15.3781 14.76C15.4167 14.7214 15.4473 14.6755 15.4682 14.6251C15.4891 14.5746 15.4999 14.5206 15.4999 14.466C15.4999 14.4114 15.4891 14.3573 15.4682 14.3068C15.4473 14.2564 15.4167 14.2105 15.3781 14.1719ZM2.1935 6.32158C2.1935 5.49916 2.43737 4.6952 2.89429 4.01138C3.3512 3.32756 4.00063 2.79459 4.76045 2.47986C5.52027 2.16514 6.35635 2.08279 7.16297 2.24324C7.96959 2.40368 8.71052 2.79972 9.29206 3.38126C9.8736 3.9628 10.2696 4.70373 10.4301 5.51035C10.5905 6.31697 10.5082 7.15305 10.1935 7.91287C9.87873 8.67269 9.34576 9.32212 8.66194 9.77904C7.97812 10.2359 7.17416 10.4798 6.35174 10.4798C5.24929 10.4786 4.19234 10.0401 3.41279 9.26053C2.63324 8.48098 2.19474 7.42403 2.1935 6.32158Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function PersonalInfo(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M3.83335 2.5H16.1667C16.4428 2.5 16.6667 2.72386 16.6667 3V4.58333H3.33335V3C3.33335 2.72386 3.55721 2.5 3.83335 2.5Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 6.5C1 6.22386 1.22386 6 1.5 6H18.5C18.7761 6 19 6.22386 19 6.5V18.5C19 18.7761 18.7761 19 18.5 19H1.5C1.22386 19 1 18.7761 1 18.5V6.5ZM13.8332 11.5833H6.1665C5.89036 11.5833 5.6665 11.3595 5.6665 11.0833V10.5C5.6665 10.2239 5.89036 10 6.1665 10H13.8332C14.1093 10 14.3332 10.2239 14.3332 10.5V11.0833C14.3332 11.3595 14.1093 11.5833 13.8332 11.5833ZM11.3332 14.9193H6.1665C5.89036 14.9193 5.6665 14.6954 5.6665 14.4193V13.8359C5.6665 13.5598 5.89036 13.3359 6.1665 13.3359H11.3332C11.6093 13.3359 11.8332 13.5598 11.8332 13.8359V14.4193C11.8332 14.6954 11.6093 14.9193 11.3332 14.9193Z"
				fill="black"
			/>
		</svg>
	);
}

function Stats(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M7.5 1.5C7.5 1.22386 7.72386 1 8 1H12C12.2761 1 12.5 1.22386 12.5 1.5V18.5C12.5 18.7761 12.2761 19 12 19H8C7.72386 19 7.5 18.7761 7.5 18.5V1.5Z"
				fill="black"
			/>
			<path
				d="M0.5 8.5C0.5 8.22386 0.723858 8 1 8H5C5.27614 8 5.5 8.22386 5.5 8.5V18.5C5.5 18.7761 5.27614 19 5 19H1C0.723858 19 0.5 18.7761 0.5 18.5V8.5Z"
				fill="black"
			/>
			<path
				d="M15 5C14.7239 5 14.5 5.22386 14.5 5.5V18.5C14.5 18.7761 14.7239 19 15 19H19C19.2761 19 19.5 18.7761 19.5 18.5V5.5C19.5 5.22386 19.2761 5 19 5H15Z"
				fill="black"
			/>
		</svg>
	);
}

function Edit(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_631:1036)">
				<path
					d="M18.6054 6.97793C18.7752 6.80815 18.7752 6.53287 18.6054 6.36308L13.6866 1.44424C13.5168 1.27445 13.2415 1.27446 13.0717 1.44424L10.7485 3.76745L16.2822 9.30114L18.6054 6.97793Z"
					fill="black"
				/>
				<path
					d="M14.6836 10.8998L7.35323 18.2301C7.27071 18.3127 7.15849 18.3585 7.0418 18.3575L2.71782 18.3241C2.17156 18.3199 1.72977 17.8781 1.72556 17.3319L1.69221 13.0079C1.69114 12.8912 1.73702 12.779 1.81953 12.6965L9.14992 5.36607L14.6836 10.8998Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_631:1036">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

function Worker(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_631:3075)">
				<path
					d="M7.45498 9.06783C8.16606 9.66989 9.06764 10.0002 9.99936 10C10.9311 10.0002 11.8327 9.66988 12.5437 9.06783C13.2548 8.46578 13.7293 7.63102 13.8827 6.71202L14.1796 4.93197C14.2806 4.32502 14.2482 3.70335 14.0846 3.11018C13.9211 2.51702 13.6303 1.96661 13.2324 1.49723C12.8346 1.02785 12.3393 0.650762 11.7809 0.392198C11.2226 0.133634 10.6146 -0.000200838 9.99935 2.26705e-07C9.38405 -0.000201057 8.77609 0.133634 8.21775 0.392198C7.65942 0.650761 7.16411 1.02785 6.76627 1.49723C6.36843 1.96661 6.07762 2.51702 5.91405 3.11018C5.75049 3.70335 5.71809 4.32502 5.81913 4.93197L6.11596 6.71202C6.26943 7.63102 6.7439 8.46578 7.45498 9.06783Z"
					fill="black"
				/>
				<path
					d="M2.0829 19.1667H17.9158C17.9709 19.1667 18.0255 19.1558 18.0763 19.1346C18.1272 19.1134 18.1733 19.0823 18.2121 19.0431C18.2509 19.004 18.2815 18.9575 18.3022 18.9064C18.3229 18.8554 18.3332 18.8007 18.3327 18.7456L18.3014 15.7862C18.2971 15.0946 18.115 14.4158 17.7724 13.815C17.4299 13.2142 16.9385 12.7117 16.3456 12.3557C15.6435 11.9425 14.8507 11.7079 14.0368 11.6724C13.8786 11.6667 13.7212 11.6974 13.5768 11.7621C12.4491 12.2573 11.2309 12.513 9.99935 12.513C8.76776 12.513 7.54958 12.2573 6.42195 11.7621C6.27747 11.6974 6.12009 11.6667 5.9619 11.6724C5.148 11.7079 4.35525 11.9425 3.65315 12.3557C3.0602 12.7117 2.56882 13.2142 2.22629 13.815C1.88376 14.4158 1.70159 15.0946 1.69732 15.7862L1.66604 18.7456C1.66547 18.8007 1.67583 18.8554 1.69653 18.9064C1.71723 18.9575 1.74785 19.004 1.78661 19.0431C1.82538 19.0823 1.87153 19.1133 1.92239 19.1346C1.97324 19.1558 2.0278 19.1667 2.0829 19.1667Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_631:3075">
					<rect width="20" height="20" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

function Copy2(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M13.6364 2.36364V4.54545C13.6364 4.6419 13.5981 4.73439 13.5299 4.80258C13.4617 4.87078 13.3692 4.90909 13.2727 4.90909H4.90909V13.2727C4.90909 13.3692 4.87078 13.4617 4.80258 13.5299C4.73439 13.5981 4.6419 13.6364 4.54545 13.6364H2.36364C2.26719 13.6364 2.1747 13.5981 2.10651 13.5299C2.03831 13.4617 2 13.3692 2 13.2727V2.36364C2 2.26719 2.03831 2.1747 2.10651 2.10651C2.1747 2.03831 2.26719 2 2.36364 2H13.2727C13.3692 2 13.4617 2.03831 13.5299 2.10651C13.5981 2.1747 13.6364 2.26719 13.6364 2.36364Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.81119 6.36364H17.5524C17.7996 6.36364 18 6.56401 18 6.81119V17.5524C18 17.7996 17.7996 18 17.5524 18H6.81119C6.56401 18 6.36364 17.7996 6.36364 17.5524V6.81119C6.36364 6.56401 6.56401 6.36364 6.81119 6.36364Z"
				fill="black"
			/>
		</svg>
	);
}

function ThreeDots(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<circle cx="5" cy="1.5" r="1.5" fill="black" />
			<circle cx="1.5" cy="7.5" r="1.5" fill="black" />
			<circle cx="8.5" cy="7.5" r="1.5" fill="black" />
		</svg>
	);
}

function ExternalLink(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" {...props}>
			<path
				d="M12.0132 13.2673C12.2918 13.2685 12.5176 13.0417 12.5152 12.7631L12.4646 6.74899C12.4623 6.47614 12.2417 6.25552 11.9688 6.25322L5.95579 6.20259C5.67679 6.20024 5.44984 6.42669 5.45159 6.7057L5.45541 7.31558C5.45712 7.58902 5.67816 7.81036 5.9516 7.81244L9.69142 7.84085L4.44305 13.0892C4.24779 13.2845 4.24779 13.6011 4.44305 13.7963L4.92147 14.2747C5.11673 14.47 5.43332 14.47 5.62858 14.2747L10.8769 9.02638L10.9085 12.769C10.9108 13.0427 11.1327 13.2637 11.4064 13.2648L12.0132 13.2673Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function UnionIcon(props: SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="16" height="20" fill="none" {...props}>
			<path
				d="M5.917.417A.417.417 0 0 0 5.5.833V2.5c0 .23.187.417.417.417h4.166c.23 0 .417-.187.417-.417V.833a.417.417 0 0 0-.417-.416H5.917Z"
				fill="#000"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M.917 1.666a.417.417 0 0 0-.417.417V18.75c0 .23.187.417.417.417h14.166c.23 0 .417-.187.417-.417V2.083a.417.417 0 0 0-.417-.417h-2.5a.417.417 0 0 0-.416.417v2.084c0 .23-.187.416-.417.416h-7.5a.417.417 0 0 1-.417-.416V2.083a.417.417 0 0 0-.416-.417h-2.5Zm10 6.667a.417.417 0 0 0-.417.417v.833c0 .23.187.417.417.417h.833c.23 0 .417-.186.417-.417V8.75a.417.417 0 0 0-.417-.417h-.833Zm-.417 4.584c0-.23.187-.417.417-.417h.833c.23 0 .417.187.417.417v.833c0 .23-.187.417-.417.417h-.833a.417.417 0 0 1-.417-.417v-.833ZM4.25 8.333a.417.417 0 0 0-.417.417v.833c0 .23.187.417.417.417h4.167c.23 0 .416-.186.416-.417V8.75a.417.417 0 0 0-.416-.417H4.25Zm-.417 4.584c0-.23.187-.417.417-.417h4.167c.23 0 .416.187.416.417v.833c0 .23-.186.417-.416.417H4.25a.417.417 0 0 1-.417-.417v-.833Z"
				fill="#000"
			/>
		</svg>
	);
}

function KeyIcon(props: SVGAttributes<HTMLOrSVGElement>) {
	return (
		<svg width="24" height="24" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.38 9.857a5.002 5.002 0 0 0 5.643-8.071A5 5 0 0 0 4.981 7.49L.333 12v2.5h2.5v-1.666h1.618v-1.667h1.715l1.214-1.31Zm2.17-4.372a1.25 1.25 0 1 0 1.768-1.768A1.25 1.25 0 0 0 9.55 5.485Z"
				fill="#000"
			/>
		</svg>
	);
}

function HamburgerIcon() {
	return (
		<svg width="24" height="24" fill="none" viewBox="0 0 24 24">
			<path fill="#000" d="M1 7h22v2H1zM1 15h22v2H1z" />
		</svg>
	);
}

function LanguageIcon(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" {...props}>
			<path
				d="M16.636 5.667a8.354 8.354 0 0 0-4.569-4.41 13.535 13.535 0 0 1 1.29 4.41h3.279Zm.53 1.666h-3.639a24.918 24.918 0 0 1 0 3.333h3.64a8.377 8.377 0 0 0 0-3.333ZM9 17.333c1.196 0 2.223-2.058 2.673-5H6.328c.45 2.942 1.477 5 2.672 5Zm-2.858-10a23.56 23.56 0 0 0 0 3.333h5.717a23.59 23.59 0 0 0 0-3.333H6.142Zm-4.777 5a8.354 8.354 0 0 0 4.569 4.41 13.537 13.537 0 0 1-1.29-4.41H1.365Zm10.702 4.41a8.354 8.354 0 0 0 4.569-4.41h-3.28a13.536 13.536 0 0 1-1.289 4.41ZM1.365 5.667h3.279a13.536 13.536 0 0 1 1.29-4.41 8.354 8.354 0 0 0-4.569 4.41ZM4.417 9c0-.558.02-1.115.057-1.667H.834a8.38 8.38 0 0 0 0 3.333h3.64A25.627 25.627 0 0 1 4.417 9ZM9 .667c-1.195 0-2.222 2.058-2.672 5h5.345c-.45-2.942-1.477-5-2.673-5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

function QuestionIcon(props: React.SVGAttributes<HTMLOrSVGElement>): React.ReactElement {
	return (
		<svg width="18" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M3.72168 14.5195V12.5195H5.72168V14.5195H3.72168Z"
				fill="black"
			/>
			<path
				d="M1 5C1 2.79086 2.79086 1 5 1C7.20914 1 9 2.79086 9 5C9 7.20914 7.20914 9 5 9H3.71922"
				stroke="black"
				stroke-width="2"
			/>
		</svg>
	);
}
